import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import { LayoutLegacy } from "@silvertours/front-legacy-entities";
import { BreadcrumbsContentContainer, BreadcrumbItem, BreadcrumbList, BreadcrumbText, BreadcrumbLink } from "./PageNavigation.styles";
var BreadcrumbListItem = function(param) {
    var _breadcrumb = param.breadcrumb, name = _breadcrumb.name, url = _breadcrumb.url, isLast = param.isLast, index = param.index;
    var shouldRenderText = isLast || !url;
    return /*#__PURE__*/ _jsxs(BreadcrumbItem, {
        itemProp: "itemListElement",
        itemScope: true,
        itemType: "https://schema.org/ListItem",
        children: [
            shouldRenderText ? /*#__PURE__*/ _jsx(BreadcrumbText, {
                isLast: isLast,
                "aria-current": "page",
                itemProp: "name",
                children: name
            }) : /*#__PURE__*/ _jsx(BreadcrumbLink, {
                href: url,
                itemProp: "item",
                children: /*#__PURE__*/ _jsx("span", {
                    itemProp: "name",
                    children: name
                })
            }),
            /*#__PURE__*/ _jsx("meta", {
                itemProp: "position",
                content: String(index + 1)
            })
        ]
    });
};
var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    if (!breadcrumbs || breadcrumbs.length === 0) {
        return null;
    }
    var lastIndex = breadcrumbs.length - 1;
    return /*#__PURE__*/ _jsx(LayoutLegacy.PlainSegment, {
        id: "breadcrumbs",
        hasPadding: true,
        spacingScale: 0.5,
        children: /*#__PURE__*/ _jsx(BreadcrumbsContentContainer, {
            children: /*#__PURE__*/ _jsx(BreadcrumbList, {
                itemScope: true,
                itemType: "https://schema.org/BreadcrumbList",
                children: breadcrumbs.map(function(breadcrumb, index) {
                    return /*#__PURE__*/ _jsx(BreadcrumbListItem, {
                        isLast: index === lastIndex,
                        breadcrumb: breadcrumb,
                        index: index
                    }, breadcrumb.name);
                })
            })
        })
    });
};
export { Breadcrumbs };
